import { copyText } from './CopyLink';
import { toast } from './toast';

export interface ComposeLink {
  channel: 'email' | 'sms';
  /** mailto: or sms: link with the message filled in. */
  href: string;
  to: string;
  /** The text, so it can be copied when the device has no mail or messaging app. */
  body?: string;
}

/** What an invite hands back when the office should send it from its own device. */
export interface InviteCompose {
  email?: { href: string; to: string };
  sms?: { href: string; to: string };
}

export const inviteLinks = (c: InviteCompose | undefined): ComposeLink[] => [
  ...(c?.email ? [{ channel: 'email' as const, ...c.email }] : []),
  ...(c?.sms ? [{ channel: 'sms' as const, ...c.sms }] : []),
];

/**
 * Opens a prepared message in the device's own mail or messaging app. The app
 * decides who it comes from, so the office sees which account will send it.
 * With `onDone`, the office says afterwards whether they sent it.
 */
export function ComposeButtons(props: {
  items: ComposeLink[];
  onDone?: (status: 'sent' | 'skipped') => void;
}) {
  if (props.items.length === 0) return null;
  const hasEmail = props.items.some((i) => i.channel === 'email');
  return (
    <div className="compose stack-tight">
      <div className="row wrap">
        {props.items.map((i) => (
          <span key={i.channel} className="row wrap compose-one">
            <a className="button" href={i.href} title={`To ${i.to}`}>
              {i.channel === 'email' ? 'Open email' : 'Open SMS'}
            </a>
            {i.body && (
              <button
                type="button"
                className="quiet"
                onClick={() =>
                  void copyText(i.body!).then((ok) =>
                    toast(ok ? 'Message copied.' : 'Could not copy. Select the text instead.'),
                  )
                }
              >
                Copy text
              </button>
            )}
          </span>
        ))}
        {props.onDone && (
          <>
            <button type="button" className="quiet" onClick={() => props.onDone!('sent')}>
              Mark sent
            </button>
            <button type="button" className="quiet" onClick={() => props.onDone!('skipped')}>
              Skip
            </button>
          </>
        )}
      </div>
      {hasEmail && (
        <p className="muted compose-note">Sends from the email account on this device.</p>
      )}
    </div>
  );
}
